export const environment = {
  production: true,
  // urlApi: 'https://nitroimob.com.br/',
  urlApi: 'https://d2svs346bx6137.cloudfront.net/',
  apiUrl: 'https://api.cancianimoveis.com.br',
  //apiUrl: 'http://localhost:3009'

};

